import { checkUserFocusMpApi, generateMpQrcodeApi } from '~/server'

/**
 * 是否关注公众号
 */
export function useFocusMP() {
  const showDialog = ref(false)
  const qrcodeUrl = useSessionStorage('USER_WX_MP_QRCODE', '')
  const isFocusMp = useSessionStorage('USER_WX_MP_FOCUS', false)
  const { getUserInfoItem } = useAuth()

  watch(showDialog, async () => {
    const userId = getUserInfoItem('id')
    if (showDialog.value && userId) {
      const { data } = await generateMpQrcodeApi(String(userId))
      if (data)
        qrcodeUrl.value = data
    }
  })
  async function checkUserFocusMp() {
    const { data } = await checkUserFocusMpApi()
    if (data)
      isFocusMp.value = data
    if (isFocusMp.value)
      return
    showDialog.value = true
  }

  return {
    showDialog,
    qrcodeUrl,
    checkUserFocusMp,
  }
}
